import axios from 'axios';
const instance = axios.create({
    baseURL: 'https://parabolics.herokuapp.com/',
});


export default instance;